import { render, staticRenderFns } from "./Play_Worth.vue?vue&type=template&id=21d5f87c&scoped=true"
import script from "./Play_Worth.vue?vue&type=script&lang=js"
export * from "./Play_Worth.vue?vue&type=script&lang=js"
import style0 from "./Play_Worth.vue?vue&type=style&index=0&id=21d5f87c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d5f87c",
  null
  
)

export default component.exports